module.exports = {
    init : function ($) {
        this.addAttributeToTag($,'img','alt','not found');
        var slideIndex = 1;
        var  scrollStep = 200;
    _this = this;
    $('.portfolio-slide-prev').click(function(e) {
        _this.showSlides(slideIndex += -1);
    });
    $('.portfolio-slide-next').click(function(e) {
      _this.showSlides(slideIndex += 1);
    });
    $('.dot').click(function(e) {
        _this.showSlides(e.target.id.split("-")[1]);
      });
    $('.righty').click(function(e) {
    var content = document.getElementsByClassName("outer")[0];
    let sl = content.scrollLeft,
        cw = content.scrollWidth;
    if ((sl + scrollStep) >= cw) {
        content.scroll(cw,0);
    } else {
        content.scroll(sl + scrollStep,0);
    }
  });
  
  $('#modal-div').click((e) => {
    if (e.target !== e.currentTarget) {
        return;
    }
    $('body').removeClass('no-scroll');
      $("#modal-div").css("display", "none");
  });
  $('.display-image').click(() => {
    $("#modal-div").css("display", "block");
});

    $('.lefty').click(function(e) {
    var content = document.getElementsByClassName("outer")[0];
    let sl = content.scrollLeft;
      
    if ((sl - scrollStep) <= 0) {
        content.scroll(0,0);
    } else {
        content.scroll(sl - scrollStep,0);
    }
  });
  $('#gallery-div .inner').click((e) => {
        $('.display-image').attr('src', e.target.src);
        $('body').addClass('no-scroll');
        $("#modal-div").css("display", "block");
  })

},
    showSlides(n) {
        var i,slideIndex;
        var slides = document.getElementsByClassName("slide");
        var len = slides.length;
        var dots = document.getElementsByClassName("dot");
        if (n < 1) { slideIndex = len - (Math.abs(n)% len) -1; }
        else { slideIndex = (n-1) % slides.length;}
        for (i = 0; i < slides.length; i++) {
            slides[i].style.display = "none";
            dots[i].className = dots[i].className.replace(" active", "");
        }
        if(slideIndex < len){
        slides[slideIndex].style.display = "flex";
        dots[slideIndex].className += " active";
        }
    },
    addAttributeToTag($,tagName, attributeName,value){
        $(tagName).each((index,element)=> {
        if(!$(element).attr(attributeName)) {
            $(element).attr(attributeName, value);
         }
        });
    }
}